import React, { Component } from 'react';
import SideLink from './sidelink';
import AsideDropdown from './asideDropdown';
import { LOCAL_STORAGE } from '../utils/constants';

class Asidebar extends Component {
    render() {
        let imageSrc = '';
        let imgIconWidth = "100%";

        switch (LOCAL_STORAGE.customerNo) {
            case '1158':
                imageSrc = "assets/img/snowlink_logo.jpg";
                break;
            case '1175':
                imageSrc = "assets/img/ptpl-logo.png";
                break;
            case '549':
                imageSrc = "assets/img/reema.png";
                imgIconWidth = "100%";
                break;
            case '353':
                imageSrc = "assets/img/saharaRL.png";
                break;
            case '1568':
                imageSrc = `${process.env.REACT_APP_BASE_URL}/profile_images/${LOCAL_STORAGE.customerLogo}`;
                imgIconWidth = "100%";
                break;
            case '503':
                imageSrc = `${process.env.REACT_APP_BASE_URL}/profile_images/${LOCAL_STORAGE.customerLogo}`;
                imgIconWidth = "100%";
                break;
            case '1341':
                imageSrc = `${process.env.REACT_APP_BASE_URL}/profile_images/${LOCAL_STORAGE.customerLogo}`;
                break;
            default:
                imageSrc = "assets/img/logo.png";
                break;
        };

        return (
            <React.Fragment>
                <div id="sidebars">
                    <aside id="asidebar" className="sidenav smallSiderbar">
                        <div className="img-thumbnail">
                            <img src={imageSrc}
                                alt=""
                                className="sidelogo pt-1"
                                style={{ objectFit: 'contain', width: imgIconWidth, display: 'block', marginRight: 'auto', marginLeft: 'auto' }}
                            />
                        </div>
                        {LOCAL_STORAGE.role === 'vendor' ?
                            <>
                                <SideLink imgLink="assets/svg/jobcards.svg" linkTo="jobcard" linkName='Jobcard' />
                            </>
                            :
                            <>
                                {/* <SideLink Exact={true} imgLink='assets/svg/dashboard.svg' linkTo='/' linkName="Dashboard" /> */}
                                <SideLink Exact={true} imgLink='assets/svg/report.svg' linkTo='/salesorder' linkName="Sales Order" />
                                <SideLink Exact={true} imgLink='assets/svg/Billing Platform.svg' linkTo='/customerinvoice' linkName="Customer Invoice" />
                                <SideLink Exact={true} imgLink='assets/svg/Billing Platform.svg' linkTo='/credit-note' linkName="Credit Note" />
                                <SideLink Exact={true} imgLink='assets/svg/detention.svg' linkTo='/receivable' linkName="Receivables" />
                                {/* <SideLink Exact={true} imgLink='assets/svg/report.svg' linkTo='/debitnote' linkName="Debit Note" />
                                <SideLink Exact={true} imgLink='assets/svg/report.svg' linkTo='/reports' linkName="Reports" /> */}
                                <AsideDropdown />
                            </>
                        }
                    </aside>
                </div>
            </React.Fragment>
        )
    }
}

export default Asidebar
